import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionPlugin } from '../../../shared/models';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService } from '../../../shared/services';

@Injectable()
export class InstallationBobstAttendeesPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected factory: InspectionFactoryService
  ) {
    super(apiService, dataService, null);
  }

  public getBobstContacts(inspectionId: string): Observable<any[]> {
    return this.dataService
      .getParrentInspectionLevelPlugin(inspectionId, 'installationbobstcontact')
      .map((p) => p?.config?.Team ?? [])
      .map((team: any[]) =>
        team.map((t) => ({
          Email: t.Email,
          Phone: t.Phone,
          JobFunction: t.Function ?? '',
          FirstName: t.Name,
          LastName: t.LastName
        }))
      );
  }

  public updateAttendees(inspectionId: string, pointId: string, pluginId: string, attendees: any[]): Observable<any> {
    attendees.forEach((r) => {
      if (!r.Id) {
        r.Id = this.factory.guid();
      }
    });
    return this.update(inspectionId, pointId, pluginId, attendees).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, anilox: any[]): Observable<any> {
    return this.factory.updatePluginConfig(inspectionId, pointId, pluginId, anilox, 'Attendees').pipe(
      flatMap((plugin: InspectionPlugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
